import styled, { css } from 'styled-components';
import UniversalLink from '@/components/UniversalLink';

export const Img = styled.img`
  border-radius: 6px;
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const Ul = styled.ul`
  ${({ theme }) => theme.typography.editorBody};
  color: ${({ theme }) => theme.color.lightGray};
  list-style-type: disc;
  padding-left: ${(props) => props.theme.x2spacePx}px;

  li {
    padding-left: ${(props) => props.theme.x1spacePx}px;
  }
`;

export const Ol = styled.ol`
  ${({ theme }) => theme.typography.editorBody};
  color: ${({ theme }) => theme.color.lightGray};
  list-style: decimal;
  padding-left: ${(props) => props.theme.x2spacePx}px;

  li {
    padding-left: ${(props) => props.theme.x1spacePx}px;
  }
`;

const linkStyles = css`
  ${({ theme }) => theme.typography.editorBody};
  color: ${({ theme }) => theme.color.lightGray};
  text-decoration: underline;

  &:hover,
  &:visited {
    background-color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
  }
`;

export const StyledLink = styled('a')`
  ${linkStyles}
`;

export const StyledUniversalLink = styled(UniversalLink)`
  ${linkStyles}
`;
